import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthRoot } from "./components/ConfigProvider";
import "./index.css";

// Installable on a phone: the manifest and a minimal service worker (network first, never caches the API).
if ("serviceWorker" in navigator && location.protocol === "https:") {
  window.addEventListener("load", () => { navigator.serviceWorker.register("/sw.js").catch(() => { /* install is optional */ }); });
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 5_000 } },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* AuthRoot mounts ClerkProvider only when the deployment runs Clerk; passcode and dev modes pass straight through. */}
        <AuthRoot>
          <App />
        </AuthRoot>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
